import React from 'react';

import { APIEntityType } from '@cd3p/core/types/api';
import { SENSITIVE_FIELD_PLACEHOLDER } from '@cd3p/core/utils/sensitiveData';
import { Message } from '@chatscope/chat-ui-kit-react';
import { SensitiveData } from 'features';
import { ChatMessage } from 'selectors/chat';

import { useMessageAttachment } from './useMessageAttachment';

import { he } from 'third-party';

import {
  MessageInnerContent,
  MessageSendTime,
} from 'features/Chat/MessageBubbleStyles';

type Props = {
  as?: any;
  userId?: string;
  senderDisplayName: string;
  showUserName: boolean;
  message: ChatMessage;
  isBotMessage?: boolean;
  hasSensitiveData?: boolean;
  sensitiveEntityId?: string | number;
  sensitiveEntityType?: APIEntityType;
};

export const UserMessageBubble: React.FC<Props> = ({
  userId,
  senderDisplayName,
  showUserName,
  message,
  isBotMessage,
  hasSensitiveData,
  sensitiveEntityId,
  sensitiveEntityType,
}) => {
  const { renderMessageAttachment } = useMessageAttachment({
    attachmentIds: message.attachmentIds,
  });
  return (
    <Message
      model={{
        direction: message.senderId == userId ? 'outgoing' : 'incoming',
        position: 'single',
      }}
      className={isBotMessage ? 'bot-message' : ''}
    >
      {showUserName && (
        <Message.Header title={senderDisplayName} sender={senderDisplayName} />
      )}
      <Message.CustomContent>
        <MessageInnerContent>
          {renderMessageAttachment()}
          <div>
            {hasSensitiveData ? (
              <SensitiveData
                text={SENSITIVE_FIELD_PLACEHOLDER}
                entityId={sensitiveEntityId}
                entityType={sensitiveEntityType}
              />
            ) : (
              he.decode(message.message)
            )}
          </div>
          <MessageSendTime>{message.sendTime}</MessageSendTime>
        </MessageInnerContent>
      </Message.CustomContent>
    </Message>
  );
};
